/**
 * Invoices
 */
waApp.controllers.Invoices = {
	pay: function() {
		var $form = $('#invoice-form');

		var stripeResponseHandler = function(status, response) {
			if (response.error) {
				// Show the errors on the form
				$('#payment-errors').removeClass('hidden').html(response.error.message);
				console.log(response);
				//$form.find('button').prop('disabled', false);
			} else {
				// token contains id, last4, and card type
				var token = response.id;

				$('#payment-errors').addClass('hidden');
				// Insert the token into the form so it gets submitted to the server
				$form.append($('<input type="hidden" name="stripeToken" />').val(token));
				// and submit
				$form.get(0).submit();
			}
		};

		$form.submit(function(event) {
			event.preventDefault();

			// Disable the submit button to prevent repeated clicks:
			$form.find('.submit').prop('disabled', true);

			// Request a token from Stripe:
			var cardData = {
				// jscs: disable
				name: $('#cc-first-name').val() + ' ' + $('#cc-first-name').val(),
				number: $('#cc-number').val(),
				cvc: $('#cc-cvc').val(),
				exp_month: $('#cc-month').val(),
				exp_year: $('#cc-year').val()
				// jscs: enable
			};

			Stripe.card.createToken(cardData, stripeResponseHandler);
		});
	}
};
